import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Redirect } from 'react-router-dom';

import Btn from '../../components/Btn';
import ClientsList from '../ClientsList/ClientsList';


import '../../grid.css';
import './clientdashboard.css';

class ClientDashboard extends Component {
    componentDidMount() {
        if (this.props.authToken) {
            this.props.getClientsList(this.props.authToken);
            this.props.setClientId(null);
        }
    }
    handleToggleDelete() {
        const { toggleDelete, setToggleDelete } = this.props;
        setToggleDelete(!toggleDelete);
    }
    render() {
        const {
            clientsList, authToken, clientUpdateStatus,
        } = this.props;
        if (!authToken) return <Redirect to="/" />;
        if (!clientsList) return <p>LOADING...</p>;
        return (
            <div>
                <div className="row dashboard-content">
                    <h1 className="dashboardTitle">Clients Dashboard</h1>
                    <Btn
                        className="navBtn clientNavBtn"
                        label="Add Customer"
                        to="/addclient"
                        fullWidth={false}
                    />
                    <Btn
                        className="navBtn clientNavBtn"
                        fullWidth={false}
                        to="/customers"
                        onClick={(e, value) => this.handleToggleDelete(value)}
                        label="Edit List"
                    />
                    <p className="errorMsg">{clientUpdateStatus || null }</p>
                    <div className="clientSection">
                        <ClientsList clients={clientsList} authToken={authToken} />
                    </div>
                </div>
            </div>
        );
    }
}

ClientDashboard.propTypes = {
    clientsList: PropTypes.array,
    authToken: PropTypes.string.isRequired,
    clientUpdateStatus: PropTypes.string.isRequired,
    setToggleDelete: PropTypes.func.isRequired,
    getClientsList: PropTypes.func.isRequired,
    setClientId: PropTypes.func.isRequired,
    toggleDelete: PropTypes.bool.isRequired,
};

ClientDashboard.defaultProps = {
    clientsList: [],
};

export default ClientDashboard;



// WEBPACK FOOTER //
// ./src/containers/ClientsDashboard/ClientDashboard.js